module.exports = __webpack_public_path__ + "static/img/company1.45b286f.45b286f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company1.45b286f.png
// module id = GzMA
// module chunks = 44